import React from "react";
import PropTypes from "prop-types";
import { Caption } from "@xo-union/tk-ui-typography";
var SubText = function SubText(_ref) {
  var className = _ref.className,
    id = _ref.id,
    state = _ref.state,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Caption, {
    id: id,
    className: className,
    "aria-live": state === 'invalid' ? 'polite' : undefined
  }, children);
};
process.env.NODE_ENV !== "production" ? SubText.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  state: PropTypes.string,
  children: PropTypes.node
} : void 0;
export default SubText;